import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "pond";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    pondData: {
      list: [],
      total: 0,
    },
    fishPondNoBatch: [], // 获取基地下已清塘的鱼塘
  },
  actions: {
    //获取塘口设置列表
    async getPondList({ commit }, payload) {
      let result = await api.get(
        `/api/FishPond?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setPondList", result.data);
      }
      return result;
    },
    //删除塘口设置
    async delPondList(action, payload) {
      let result = await api.delete(`/api/FishPond/` + payload);
      return result;
    },
    // 添加塘口设置
    async addPondSettingList(action, payload) {
      let result = await api.post("/api/FishPond", payload);
      return result;
    },
    //获取塘口设置单行数据
    async getEditPondData(a, payload) {
      let result = await api.get(`/api/FishPond/` + payload);
      return result;
    },
    //修改保存塘口设置
    async editPondSettingList(action, payload) {
      let result = await api.put("/api/FishPond", payload);
      return result;
    },
    //获取塘口
    async getFishPond(a, payload) {
      let result = await api.get(`/api/FishPond/KeyValue/${payload}`);
      return result.data;
    },
    // 获取基地下已清塘的鱼塘键值对列表
    async getFishPondNoBatch({ commit }, payload) {
      let result = await api.get(`/api/FishPond/NoBatch/${payload}`);
      if (result.status === 200) {
        commit("setFishPondNoBatch", result.data);
      }
      return result;
    },
  },
  mutations: {
    setPondList(state, payload) {
      state.pondData = payload;
    },
    setFishPondNoBatch(state, payload) {
      state.fishPondNoBatch = payload;
    },
  },
});

export default moduleName;
